import styled from 'styled-components';
import { MOBILE_FOOTER_HEIGHT } from '../../dashboard/DashboardLayout';
import { Button } from '../../input/Button';
import { Box } from '../../layout/Box';

export const ActionButtonWrapper = styled(Box)
    .withConfig({ displayName: 'ActionButtonWrapper' })
    .attrs({
        position: 'sticky',
        bottom: { xs: `calc(${MOBILE_FOOTER_HEIGHT}px)`, sm: 0 },
        width: '100%',
        py: 2,
        mt: 'auto',
        backgroundColor: 'var(--background-primary)',
    })``;

export const ActionButton = styled(Button)
    .withConfig({ displayName: 'ActionButton' })
    .attrs((props) => ({
        width: '100%',
        color: 'primary',
        ...props,
    }))``;
